<ion-content class="ion-no-padding">
  <div class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">
          <span *ngIf="!editVisaInformationId">Add</span><span *ngIf="editVisaInformationId">Edit</span> Country (Visa Checklist) <span *ngIf="editVisaInformationId">{{editVisaInformationId}}</span>
        </ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" type="submit" (click)="saveAndNextVisaInformation()" *ngIf="!editVisaInformationId">Save & New</ion-button>
          <ion-button class="filled-blue-btn" type="submit" (click)="saveVisaInformation()">Save</ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line"></div>
      <div class="form-container">
        <form [formGroup]="countryVisaInformationForm">
        <div>
          <div>
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">General Information</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <ng-container formGroupName="countryInfo">
              <div class="form-sub-heading-container">
                <p class="sub-heading">Details</p>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Country Name*</label>
                    <div [ngClass]="{ 'invalid-input': countryVisaInformationForm.get('countryInfo.country')?.invalid && countryVisaInformationForm.get('countryInfo.country')?.touched }">
                      <app-countries-dropdown-input formControlName="country" (selected)="countrySelected($event)"></app-countries-dropdown-input>
                    </div>
                  </div>
                </div>
  
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Currency*</label>
                    <div [ngClass]="{ 'invalid-input': countryVisaInformationForm.get('countryInfo.currency')?.invalid && countryVisaInformationForm.get('countryInfo.currency')?.touched }">
                      <input type="text" class="input" placeholder="Country's  Currency" formControlName="currency">
                    </div>
                  </div>
                </div>
  
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Time Zone*</label>
                    <div [ngClass]="{ 'invalid-input': countryVisaInformationForm.get('countryInfo.timeZone')?.invalid && countryVisaInformationForm.get('countryInfo.timeZone')?.touched }">
                      <input type="text" class="input" placeholder="Country's Time Zone" formControlName="timeZone">
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="form-sub-heading-container">
                <p class="sub-heading">Embassy Details</p>
              </div>
              <div class="row">
                <!-- <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Address</label>
                    <div [ngClass]="{ 'invalid-input': countryVisaInformationForm.get('countryInfo.address')?.invalid && countryVisaInformationForm.get('countryInfo.address')?.touched }">
                      <input type="text" class="input" placeholder="Address" formControlName="address">
                    </div>
                  </div>
                </div>
  
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Phone Number*</label>
                    <div [ngClass]="{ 'invalid-input': countryVisaInformationForm.get('countryInfo.phone')?.invalid && countryVisaInformationForm.get('countryInfo.phone')?.touched }">
                      <app-phone-country-input formControlName="phone"></app-phone-country-input>
                    </div>
                  </div>
                </div> -->
  
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Email ID*</label>
                    <div [ngClass]="{ 'invalid-input': countryVisaInformationForm.get('countryInfo.email')?.invalid && countryVisaInformationForm.get('countryInfo.email')?.touched }">
                      <input type="text" class="input" placeholder="Email Address" formControlName="email">
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Website*</label>
                    <div [ngClass]="{ 'invalid-input': countryVisaInformationForm.get('countryInfo.website')?.invalid && countryVisaInformationForm.get('countryInfo.website')?.touched }">
                      <input type="text" class="input" placeholder="Email Address" formControlName="website">
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>            
          </div>    

          <!-- Mandatory Document -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Mandatory Documents</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="mandatoryDocuments">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container  formArrayName="data">
                  <div class="document-item-container"  *ngFor="let doc of mandatoryDocumentsArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(mandatoryDocumentsArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input" placeholder="Enter document label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(mandatoryDocumentsArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes" formControlName="note">
                        </div>
                      </div>
                    </div>
                  
                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeMandatoryDocument(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="mandatoryDocumentsArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addMandatoryDocument()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Documents
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Additional docs based on visa type -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Additional Documents Based on Visa Type / Applicant Type</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="documentsBasedOnVisa">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container  formArrayName="data">
                  <ng-container *ngFor="let doc of documentsBasedOnVisaType().controls; index as i" [formGroupName]="i">
                    <div class="document-item-container">
                      <div class="doc-label-container">
                        <div class="input-container">
                          <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'name') }">
                            <i class="point-style-arrow"></i><input type="text" class="document-label input" placeholder="Enter document label" formControlName="name">
                          </div>
                        </div>
                      </div>
                      <div class="input-notes-container">
                        <div class="input-container">
                          <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'note') }">
                            <input type="text" class="doc-notes-input input" placeholder="Enter notes" formControlName="note">
                          </div>
                        </div>
                      </div>
                    
                      <div class="delete-btn-container">
                        <ion-button class="delete-btn" (click)="removeDocumentsBasedOnVisaType(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                      </div>
                    </div>

                    <div *ngIf="checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'visaTypes')">
                      <div class="input-container">
                        <p class="warning-message mb-0">Select at least one visa type</p>
                      </div>
                    </div>
                    <div class="border border-1 rounded p-1 mb-1 checkbox-container-grid">
                      <div>
                        <div class="input-container">
                          <label for="" class="label">Visa Type</label>
                        </div>
                      </div>
                      <div class="d-flex flex-wrap mb-2 px-2" *ngIf="visaTypes">
                        <div class="me-4 visa-type-item">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle" (input)="toggleSelectAllVisaType($event, i)" [checked]="checkAllVisaSelected(i)">
                            <label for="" class="checkbox-label">All</label>
                          </div>
                        </div>
                        <div class="me-4 visa-type-item" *ngFor="let visa of visaTypes;">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle" (input)="toggleVisaType($event, i, visa.key)" [checked]="checkVisaTypeSelected(i, visa.key)">
                            <label for="" class="checkbox-label">{{visa.name}}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'applicantTypes')">
                      <div class="input-container">
                        <p class="warning-message mb-0">Select at least one applicant type</p>
                      </div>
                    </div>
                    <div class="border border-1 border-dashed rounded p-1 checkbox-container-grid">
                      <div>
                        <div class="input-container">
                          <label for="" class="label">Applicant Type</label>
                        </div>
                      </div>
                      <div class="d-flex flex-wrap mb-2 px-2" *ngIf="applicantTypes">
                        <div class="me-4 visa-type-item">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle" (input)="toggleSelectAllApplicantType($event, i)" [checked]="checkAllApplicantTypeSelected(i)">
                            <label for="" class="checkbox-label">All</label>
                          </div>
                        </div>
                        <div class="me-4 visa-type-item" *ngFor="let applicant of applicantTypes">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle" (input)="toggleApplicantType($event, i, applicant.key)" [checked]="checkApplicantTypeSelected(i, applicant.key)">
                            <label for="" class="checkbox-label">{{applicant.name}}</label>
                          </div>
                        </div>
                        
                      </div>
                    </div>

                    <div class="dashed-line my-2"></div>
                    
                  </ng-container>
                  
                  <div class="w-100 py-1" *ngIf="documentsBasedOnVisaType().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addDocumentsBasedOnVisaType()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Documents
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Other documents -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Other Documents</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="otherDocuments">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container  formArrayName="data">
                  <div class="document-item-container"  *ngFor="let doc of otherDocumentsArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(otherDocumentsArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input" placeholder="Enter document label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(otherDocumentsArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes" formControlName="note">
                        </div>
                      </div>
                    </div>
                  
                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeOtherDocument(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="otherDocumentsArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addOtherDocument()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Documents
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Keys Poins to know -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Key Points to Know</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="keyPoints">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container  formArrayName="data">
                  <div class="document-item-container"  *ngFor="let doc of keyPointsToNoteArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(keyPointsToNoteArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input" placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(keyPointsToNoteArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes" formControlName="note">
                        </div>
                      </div>
                    </div>
                  
                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeKeyPointsToNote(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="keyPointsToNoteArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addKeyPointsToNote()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Prohibited/Restriced items -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Prohibited/Restricted Items</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="restrictedItems">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container  formArrayName="data">
                  <div class="document-item-container"  *ngFor="let doc of prohibitedOrRestrictedItemsArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(prohibitedOrRestrictedItemsArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input" placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(prohibitedOrRestrictedItemsArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes" formControlName="note">
                        </div>
                      </div>
                    </div>
                  
                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeProhibitedOrRestrictedItems(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="prohibitedOrRestrictedItemsArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addProhibitedOrRestrictedItems()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Important Notes -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Important Notes</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="importantNotes">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container  formArrayName="data">
                  <div class="document-item-container"  *ngFor="let doc of importantNotesArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(importantNotesArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input" placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(importantNotesArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes" formControlName="note">
                        </div>
                      </div>
                    </div>
                  
                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeImportantNotes(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="importantNotesArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addImportantNotes()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Details About Stay -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Details About Stay</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="detailsAboutStay">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container  formArrayName="data">
                  <div class="document-item-container"  *ngFor="let doc of detailsAboutStayArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(detailsAboutStayArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input" placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControlInArray(detailsAboutStayArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes" formControlName="note">
                        </div>
                      </div>
                    </div>
                  
                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeDetailsAboutStay(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="detailsAboutStayArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addDetailsAboutStay()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </form>

      </div>
    </div>
  </div>
</ion-content>
